<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'export.users.cardTitle' | transloco }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'export.selectExportTypeBelow' | transloco }}</h6>

        <hr />

        <button class="btn btn-default me-2 mb-2" (click)="download(ExportType.UsersImport)">
            {{ 'export.users.exportForImportButton' | transloco }}
        </button>
    </div>
</div>
